<template lang="html">
  <div
    class="autocomplete form-group"
    @keydown.enter="setOption"
    @keydown.tab="setOption"
    @keydown.up="moveUpward"
    @keydown.down="moveDownward">
    <label>{{ label }}</label>
    <input class="form-control" type="text" name="" v-model="value">
    <div class="autocomplete-list">
      <template v-for="(option, index) in availables" >
        <div
          :class="`item ${activeIndex === index ? 'active' : '' }`"
          :key="index"
          :index="index"
          @click="setValue(option.name, index)">
          {{ option.name }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    options: Array
  },

  data: () => ({
    value: '',
    activeIndex: 0,
    example: [
      {
        name: 'Amarillo'
      },
      {
        name: 'Ambar'
      },
      {
        name: 'Azul'
      },
      {
        name: 'Azul marino'
      },
      {
        name: 'Azul celeste'
      },
      {
        name: 'Blanco'
      },
      {
        name: 'Verde'
      },
      {
        name: 'Verde Oliva'
      },
      {
        name: 'Violeta'
      },
      {
        name: 'Negro'
      }
    ]
  }),

  computed: {
    availables () {
      const re = new RegExp(this.value, 'i')
      return this.options.filter(i => i.name.match(re))
    }
  },

  methods: {
    moveDownward (e) {
      this.activeIndex = this.activeIndex >= this.availables.length - 1
        ? this.availables.length - 1
        : this.activeIndex + 1
    },

    moveUpward (e) {
      this.activeIndex = this.activeIndex <= 0 ? 0 : this.activeIndex - 1
    },

    setOption (e) {
      const option = this.availables[this.activeIndex]
      this.value = option && option.name
      e.target.blur()
    },

    setValue (val, index) {
      this.value = val
      this.activeIndex = index
    }
  }
}
</script>

<style lang="css" scoped>
  .autocomplete {
    position: relative;
  }
  .autocomplete-list {
    /* display: none; */
    opacity: 0;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1004;
    border: solid 1px gray;
    background-color: white;
  }

  .autocomplete:focus-within .autocomplete-list {
    /* display: block; */
    opacity: 1;
  }

  .autocomplete-list .item.active {
    background-color: green;
  }

  .autocomplete-list .item:hover {
    background-color: olive;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/InputSearchList.vue